import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for referrals and awards report view.
 * @extends JetView
 */
export default class recordTableReferralsAwardsReportView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Historial'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                    {
                        id: 'UserId',
                        header: _('ID Usuario'), // User ID column
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'TransactionId',
                        header: _('Transacción ID'), // Transaction ID column
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Description column
                        width: 300,
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            height: 200,
            columns: [
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // User ID column
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'TransactionId',
                    header: _('Transacción ID'), // Transaction ID column
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Description column
                    width: 300,
                    sort: 'int',
                },
            ],
            pager: 'pagerA', // Pager for the data table
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositsDetail'; // API endpoint for fetching deposit details
        this.on(this.app, 'deposit:id', (Id) => {
            // Event listener for deposit ID
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + Id); // Load new data based on deposit ID
            $$('dtDetails').clearAll(); // Clear details data table
            $$('dtDetails').load(url + '?id=' + Id); // Load details data based on deposit ID
        });
    }
}

// FILE DOCUMENTED
